angular.module('bmsApp.dashboard')
	.controller('TrainingShareModalCtrl', TrainingShareModalCtrl);

TrainingShareModalCtrl.$inject = [
	'$scope',
	'$state',
	'$q',
	'item',
	'$ngBootbox',
	'$modalInstance',
	'SharedTrainingSvc',
	'EmployeeGroupSvc',
	'EmployeeOptionsSvc',
];

function TrainingShareModalCtrl(
	$scope,
	$state,
	$q,
	item,
	$ngBootbox,
	$modalInstance,
	SharedTrainingSvc,
	EmployeeGroupSvc,
	EmployeeOptionsSvc,
) {
	let self = this;
	let handlers = {};

	angular.extend(self, {
		loading: true,
		handlers: handlers,
		shares: [],
		datePickerConfig: angular.extend(angular.copy($scope.config.datePicker.basic), {
			options: angular.extend(angular.copy($scope.config.datePicker.basic.options), {
				parentEl: '.modal-content'
			}),
		}),
		validator: {
			config: {},
			api: {}
		},
		options: {
			shareMethods: [
				{
					id: 1,
					label: 'Employee',
				},
				{
					id: 2,
					label: 'Employee Group',
				},
			],
		},
	});


	// Handlers --------------------------------------------------------------------------------------------------------
	handlers.init = () => {
		let params = {
			filter: {
				course: item.share.course.id,
			},
		};

		let promises = {
			shares : SharedTrainingSvc.shareIndex(params),
			employees: EmployeeOptionsSvc.employee(),
			groups: EmployeeGroupSvc.options(),
		};
		$q.all(promises).then((responses) => {
			self.shares = responses.shares.data.share_collection;
			self.options.employees = responses.employees.data.options;
			self.options.groups = responses.groups.data.group_options;
			self.loading = false;
		});
	};

	handlers.cancel = () => {
		$modalInstance.close();
	};

	handlers.resetShare = () => {
		self.form.bmsEmployee = null;
		self.form.group = null;
	};

	handlers.deleteShareClick = (share) => {
		$ngBootbox.confirm('Are you sure you want to remove this share? This training course will be instantly revoked from this share')
			.then(function () {
				SharedTrainingSvc.deleteShare(share).then((response) => {
					self.shares.splice(self.shares.indexOf(share), 1);
				});
			});


	};

	handlers.submitClick = () => {
		angular.extend(self.form, {
			share: item.share,
		});

		SharedTrainingSvc.saveShare(self.form).then((response) => {
			self.shares.unshift(response.data.share);
		});
	};
}
